// LLM pipeline card. Renders the model's pinpoint region + confidence
// + condensed reasoning when complete. Shares the PipelineCard chrome
// with reverse_image; the differentiator is the per-model guess
// payload that lands on `state.guess` for ai_* slots.

import { PipelineCard } from "./PipelineCard";
import type { CardState } from "../state/store";
import type { PipelineId } from "../types/contract";

export function AiPipelineCard({
  pipeline,
  state,
}: {
  pipeline: PipelineId;
  state: CardState;
}) {
  return (
    <PipelineCard pipeline={pipeline} state={state}>
      {state.status === "complete" && state.guess ? (
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="font-semibold">{state.guess.region || "—"}</span>
            <span className="text-fg-muted text-[10px] tabular-nums">
              {state.guess.lat.toFixed(3)}, {state.guess.lng.toFixed(3)}
            </span>
            <span className="ml-auto text-[10px] tabular-nums">
              conf {(state.guess.confidence * 100).toFixed(0)}%
            </span>
          </div>
          {state.guess.reasoning && (
            <div className="text-[11px] text-fg-muted leading-snug">
              {state.guess.reasoning}
            </div>
          )}
        </div>
      ) : null}
    </PipelineCard>
  );
}
